import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';
import {
  PatientTrip
} from "../../../patient/patient-detail/patient-detail-visits/patient-visit-detail/patient-visit-detail.model";
import { Permissions } from "../../../../core/constants/permissions";
import { AuthService } from "../../../../core/services/auth.service";
import { TripBookingStatus } from "../../../../core/constants/trip-booking-status";
import { PatientService } from "../../../../core/services/patient.service";

@Component({
  selector: 'app-visit-trip',
  templateUrl: './visit-trip.component.html',
  styleUrls: ['./visit-trip.component.scss']
})
export class VisitTripComponent implements AfterViewInit {
  @Input('trip') trip: PatientTrip = new PatientTrip();
  @Input('scrollPosition') scrollPosition = 0;

  @Output('editTrip') editTrip = new EventEmitter<string>();
  @Output('deleteTrip') deleteTrip = new EventEmitter<PatientTrip>();

  @Input('visible') visible = false;

  Permissions = Permissions;
  maxTripRefreshAttempts = 10;
  tripRefreshAttempts = 0;
  refreshTripsInterval = 5000;

  constructor(public authService: AuthService, public patientService: PatientService) { }

  ngAfterViewInit(): void {
    if (this.trip.pdfGenerating) {
      this.refresh();
    }
  }

  /**
   * Called when the user chooses to delete a trip, will emit an event for the parent component to listen for
   * @param trip
   */
  onDeleteTrip(trip: PatientTrip): void {
    this.deleteTrip.emit(trip);
  }

  /**
   * Called when the user chooses to edit a trip, will emit an event for the parent component to listen for
   * @param trip
   */
  onEditTrip(trip: PatientTrip): void {
    this.editTrip.emit(trip.id);
  }

  getTripBookingStatusDescription(status: string): string {
    return TripBookingStatus.getDescription(status);
  }

  renderAmount(amount: number): string {
    if (amount === undefined || amount === null)
      return '';

    return amount.toFixed(2);
  }

  refresh() {
    if (this.tripRefreshAttempts < this.maxTripRefreshAttempts) {
      this.tripRefreshAttempts++;
      setTimeout(() => {
        this.patientService.retrievePatientTrip(this.trip.id).subscribe(trip => {
          this.trip.pdfGenerating = trip.pdfGenerating;

          if (trip.pdfGenerating) {
            this.refresh();
          }
        });
      }, this.refreshTripsInterval);
    }
  }

}
